export class SheetChange {
    constructor(optionalOptions = {}) {
        this._sheetChangeButtons = document.querySelectorAll('[data-sheet-change]');

        if (!this._sheetChangeButtons) {
            this.destructor();
            return true;
        }

        let changeCont
        let sheetContents

        this._sheetChangeButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                sheetContents = button.closest('.sheet-contents')

                if (!sheetContents) return false;

                changeCont = sheetContents.querySelector(button.dataset.sheetChange);

                if (!changeCont) return false;

                sheetContents.querySelectorAll('.sheet-contents-data').forEach((elOne) => {
                    if (!elOne.classList.contains('d-none')) {
                        elOne.classList.add('d-none')
                    }
                })

                changeCont.classList.remove('d-none');
            })
        })
    }

    destructor() {
        this._sheetChangeButtons = null;
    }
}

export default new SheetChange();
